import { useState } from "react";
import { useGetCompany } from "@/api/company.api";
import StyledSpinner from "@/components/styled/StyledSpinner";
import { RibModal } from "@/components/invoices/ribModal";
import { LitigeTable } from "@/components/invoices/litigesTab/litigeTable";
import { DisplayTypeSelectClient } from "@/components/invoices/displayTypeSelectClient";
import { InvoiceTable } from "@/components/invoices/invoicesTab/invoiceTable";
import { Button } from "@/components/ui/button";
import { LitigeModal } from "@/components/invoices/litigesTab/litigeModal";

export const InvoicesPage = () => {
  const [showRibModal, setShowRibModal] = useState<boolean>(false);
  const [displayType, setDisplayType] = useState<string>("invoice");
  const [isLitigeImportModalOpen, setIsLitigeImportModalOpen] = useState(false);

  const { data: company, isLoading: companyLoading, isError: companyError } = useGetCompany();

  if (companyLoading) {
    return (
      <div className="flex h-fit w-full flex-1 flex-col items-center justify-center gap-8 p-8">
        <StyledSpinner width="40" height="40" spinnerColor="text-brand700" />
      </div>
    );
  }

  if (companyError || !company) {
    return (
      <div className="flex h-fit w-full flex-1 flex-col items-center justify-center gap-8 p-8">
        <span>Erreur lors du chargement des données</span>
      </div>
    );
  }

  return (
    <div className="flex h-fit w-full flex-1 flex-col gap-8 p-8">
      <div className="flex w-full flex-col justify-between gap-2 md:flex-row">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-2">
            <h1 className="font-jakarta-sans text-3xl font-semibold">Factures</h1>
            <p>Toutes vos factures et litiges</p>
          </div>
        </div>
        <Button variant="outline" onClick={() => setShowRibModal(true)}>
          Voir le RIB
        </Button>
      </div>
      <div className="flex w-full flex-col gap-6">
        <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
          <div className="flex flex-col items-center justify-start gap-4 md:flex-row">
            <DisplayTypeSelectClient setDisplayType={setDisplayType} displayType={displayType} />
          </div>
          {displayType === "litige" && (
            <div className="max-w-[300px]">
              <Button onClick={() => setIsLitigeImportModalOpen(true)}>Importer un litige</Button>
            </div>
          )}
        </div>
        {displayType === "invoice" ? <InvoiceTable /> : <LitigeTable />}
      </div>
      <RibModal closeModal={() => setShowRibModal(false)} isOpen={showRibModal} rib={company.rib} />
      <LitigeModal
        handleClose={() => setIsLitigeImportModalOpen(false)}
        isOpen={isLitigeImportModalOpen}
      />
    </div>
  );
};
